import { create } from 'zustand';
import { persist } from 'zustand/middleware';

export interface AdminUser {
  id: string;
  email: string | null;
  username: string | null;
  displayName: string;
  role: 'USER' | 'MODERATOR' | 'ADMIN';
  mmr: number;
}

interface AuthState {
  token: string | null;
  user: AdminUser | null;
  status: 'unknown' | 'loading' | 'authed' | 'anon';
  setSession: (token: string, user: AdminUser) => void;
  setStatus: (s: AuthState['status']) => void;
  clear: () => void;
}

export const useAuthStore = create<AuthState>()(
  persist(
    (set) => ({
      token: null,
      user: null,
      status: 'unknown',
      setSession: (token, user) => set({ token, user, status: 'authed' }),
      setStatus: (status) => set({ status }),
      clear: () => set({ token: null, user: null, status: 'anon' }),
    }),
    {
      name: 'cd-admin:auth',
      partialize: (s) => ({ token: s.token, user: s.user }),
    },
  ),
);
